import React, { useState } from 'react';
import styled from '@emotion/styled';
import { Link } from 'gatsby';
import { colors, device } from './GlobalStyles';
import { StaticImage } from 'gatsby-plugin-image';
import { navMenu } from './nav/navMenu';

const StyledFooter = styled.footer`
    padding: 2em 0em 4em;
    background: ${colors.navy};
    .first {
        display: flex;
        flex-direction: column;
        align-items: center;
    }
    .contact-container {
        display: flex;
        margin: 1em 0em 2em 4em;
        align-items: start;
        flex-direction: column;
    }
    .social {
        width: 160px;
        display: flex;
        justify-content: space-between;
    }
    ul {
        text-align: center;
        padding: 0em;
        list-style: none;
    }
    h6 {
        text-align: center;
        margin-top: 1.5em;
        padding: 0em;
        font-size: 20px;
        color: ${colors.gold};
    }
    li {
        font-size: 18px;
        margin: 1em 0em;
        color: ${colors.white};
    }
    .contact-item {
        p {
            color: ${colors.white};
            text-decoration: underline;
            padding-left: 1em;
            position: relative;
            top: 0.4em;
            margin-right: 2em;
        }
        .map {
            width: 40px;
        }
        margin: 0.75em 0em;
        display: flex;
        align-items: center;
    }
    @media ${device.tablet} {
        ul {
            text-align: left;
        }
        h6 {
            text-align: left;
        }
        display: flex;
        padding: 4em 0em;
        justify-content: space-around;
        .lists {
            width: 520px;
            justify-content: space-between;
            display: flex;
        }
        .first {
        }
        .contact-container {
            position: relative;
            left: 6.5em;
            .map {
                width: 27px;
            }
        }
    }
`;

export const Footer: React.FC = () => {
    return (
        <StyledFooter>
            <div className="first">
                <StaticImage
                    className="logo"
                    src="../../images/svgs/logo-desktop.svg"
                    placeholder="none"
                    alt="smilecraft logo"
                />

                <div className="contact-container">
                    <h3 style={{ color: `${colors.white}` }}>Smilecraft Dental Studio</h3>
                    <a rel="noopener noreferrer" href="tel:8132354143">
                        <div className="contact-item">
                            <StaticImage
                                src="../../images/svgs/mobile-white.svg"
                                placeholder="none"
                                alt="mobile icon"
                            />
                            <p style={{ position: 'relative', left: '.6em' }}>(813) 235-4143</p>
                        </div>
                    </a>
                    <a
                        target="_blank"
                        rel="noopener noreferrer"
                        href="mailto:info@craftyoursmile.com"
                    >
                        <div className="contact-item">
                            <StaticImage
                                src="../../images/svgs/mail-white.svg"
                                placeholder="none"
                                alt="mail icon"
                            />
                            <p>info@craftyoursmile.com</p>
                        </div>
                    </a>
                    <a
                        target="_blank"
                        rel="noreferrer"
                        href="https://www.google.com/maps/place/1942+Highland+Oaks+Blvd,+Lutz,+FL+33559/data=!4m2!3m1!1s0x88c2ba29bb8ba8f5:0xa5cb651cf1a0464d?sa=X&ved=2ahUKEwiIkOORj5H2AhUVlYkEHahrCugQ8gF6BAgSEAE"
                    >
                        <div className="contact-item">
                            <StaticImage
                                className="map"
                                src="../../images/svgs/map-white.svg"
                                placeholder="none"
                                alt="map icon"
                            />
                            <p>1942 Highland Oaks Blvd Suite B, Lutz, FL 33559</p>
                        </div>
                    </a>
                </div>
                <div className="social">
                    <a
                        target="_blank"
                        rel="noopener noreferrer"
                        href="https://www.facebook.com/CraftYourSmile/"
                    >
                        <StaticImage
                            src="../../images/svgs/facebook-yellow.svg"
                            placeholder="none"
                            alt="facebook icon"
                        />
                    </a>
                    <a
                        target="_blank"
                        rel="noopener noreferrer"
                        href=" https://www.instagram.com/smilecraft_dental_studio/"
                    >
                        <StaticImage
                            src="../../images/svgs/instagram-yellow.svg"
                            placeholder="none"
                            alt="instagram icon"
                        />
                    </a>
                </div>
            </div>
            <div className="lists">
                <div>
                    <h6>Services</h6>
                    <ul>
                        {navMenu[0].menu.map(item => {
                            return (
                                <Link to={item.path}>
                                    {' '}
                                    <li>{item.name}</li>
                                </Link>
                            );
                        })}
                    </ul>
                </div>
                <div>
                    <h6>General</h6>
                    <ul>
                        <Link to="/our-difference/">
                            <li>About Us</li>
                        </Link>
                        <Link to="/contact-us/">
                            <li>Contact Us</li>
                        </Link>
                        <Link to="/membership-plans/">
                            <li>Membership Plans</li>
                        </Link>
                        <Link to="/new-patient-special/">
                            <li>New Patient Special</li>
                        </Link>
                        <Link to="/vip-list/">
                            <li>VIP Membership</li>
                        </Link>
                    </ul>
                </div>
                <div>
                    <h6>Legals</h6>
                    <ul>
                        <Link to="/privacy-policy/">
                            <li>Privacy</li>
                        </Link>
                    </ul>
                </div>
            </div>
        </StyledFooter>
    );
};
